import { gql } from "@outschool/ui-apollo";

export default gql`
  fragment EnrollmentPaymentRefundFragment on EnrollmentPaymentRefund {
    uid
    user_uid
    amount_cents
    amount_credits
    refunded_at
    reason
    user_role
    note
    reduces_teacher_payout
    amount_in_local_currency
    currency_code
    exchange_rate
    addOutschoolCreditTransaction {
      uid
      amount_cents
      expiresAt
      unspentCents
    }
  }
`;
